import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { handHeartImage } from '../../const/assets';
const HandHeartIcon = styled.img `
  object-fit: contain;
  height: 100%;
  width: 100%;
`;
const IconContainer = styled.div `
  width: 72px;
  height: 48px;
`;
const HandHeart = ({ staticHostName }) => {
    return (_jsx(IconContainer, Object.assign({ "data-testid": "hand-heart" }, { children: _jsx(HandHeartIcon, { alt: "", "aria-hidden": "true", src: `${staticHostName}${handHeartImage}` }) })));
};
export default HandHeart;
